var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClarifiant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 53.336,
    height: 53.336,
    viewBox: "0 0 53.336 53.336",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_243",
    "data-name": "Rectangle 243",
    width: 53.336,
    height: 53.336,
    rx: 15,
    transform: "translate(0)",
    fill: "#8d5c99",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_275",
    "data-name": "Rectangle 275",
    width: 35.042,
    height: 30.275,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_334",
    "data-name": "Groupe 334",
    transform: "translate(45.624 -2746.503)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_de_masques_9",
    "data-name": "Groupe de masques 9",
    transform: "translate(-45.624 2746.503)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_242",
    "data-name": "Rectangle 242",
    width: 53.336,
    height: 53.336,
    transform: "translate(0 0)",
    fill: "#8d5c99"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_248",
    "data-name": "Groupe 248",
    transform: "translate(-37.829 2766.489)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_247",
    "data-name": "Groupe 247",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_321",
    "data-name": "Trac\\xE9 321",
    d: "M228.737,1.416A1.416,1.416,0,1,1,227.32,0a1.416,1.416,0,0,1,1.416,1.416",
    transform: "translate(-209.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_322",
    "data-name": "Trac\\xE9 322",
    d: "M189.928,52.48a1.416,1.416,0,1,1-1.416-1.416,1.416,1.416,0,0,1,1.416,1.416",
    transform: "translate(-173.439 -47.337)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_323",
    "data-name": "Trac\\xE9 323",
    d: "M150.1,95.374a1.416,1.416,0,1,1-1.416-1.416,1.416,1.416,0,0,1,1.416,1.416",
    transform: "translate(-136.516 -87.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_324",
    "data-name": "Trac\\xE9 324",
    d: "M151.12,98.438a1.416,1.416,0,1,1-1.416-1.416,1.416,1.416,0,0,1,1.416,1.416",
    transform: "translate(-137.463 -89.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_325",
    "data-name": "Trac\\xE9 325",
    d: "M109.247,150.523a1.416,1.416,0,1,1-1.416-1.416,1.416,1.416,0,0,1,1.416,1.416",
    transform: "translate(-98.647 -138.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_326",
    "data-name": "Trac\\xE9 326",
    d: "M71.46,202.608a1.416,1.416,0,1,1-1.416-1.416,1.416,1.416,0,0,1,1.416,1.416",
    transform: "translate(-63.618 -186.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_327",
    "data-name": "Trac\\xE9 327",
    d: "M270.609,51.459a1.416,1.416,0,1,1-1.416-1.416,1.416,1.416,0,0,1,1.416,1.416",
    transform: "translate(-248.231 -46.39)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_328",
    "data-name": "Trac\\xE9 328",
    d: "M231.8,97.416A1.416,1.416,0,1,1,230.383,96a1.416,1.416,0,0,1,1.416,1.416",
    transform: "translate(-212.254 -88.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_329",
    "data-name": "Trac\\xE9 329",
    d: "M189.928,149.5a1.416,1.416,0,1,1-1.416-1.416,1.416,1.416,0,0,1,1.416,1.416",
    transform: "translate(-173.439 -137.277)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_330",
    "data-name": "Trac\\xE9 330",
    d: "M152.141,201.587a1.416,1.416,0,1,1-1.416-1.416,1.416,1.416,0,0,1,1.416,1.416",
    transform: "translate(-138.41 -185.56)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_331",
    "data-name": "Trac\\xE9 331",
    d: "M311.46,96.4a1.416,1.416,0,1,1-1.416-1.416A1.416,1.416,0,0,1,311.46,96.4",
    transform: "translate(-286.1 -88.046)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_332",
    "data-name": "Trac\\xE9 332",
    d: "M269.588,148.48a1.416,1.416,0,1,1-1.416-1.416,1.416,1.416,0,0,1,1.416,1.416",
    transform: "translate(-247.284 -136.33)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_333",
    "data-name": "Trac\\xE9 333",
    d: "M231.8,200.565a1.416,1.416,0,1,1-1.416-1.416,1.416,1.416,0,0,1,1.416,1.416",
    transform: "translate(-212.254 -184.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_334",
    "data-name": "Trac\\xE9 334",
    d: "M350.269,150.523a1.416,1.416,0,1,1-1.416-1.416,1.416,1.416,0,0,1,1.416,1.416",
    transform: "translate(-322.076 -138.224)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_335",
    "data-name": "Trac\\xE9 335",
    d: "M312.481,202.608a1.416,1.416,0,1,1-1.416-1.416,1.416,1.416,0,0,1,1.416,1.416",
    transform: "translate(-287.046 -186.507)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_336",
    "data-name": "Trac\\xE9 336",
    d: "M383.971,200.565a1.416,1.416,0,1,1-1.416-1.416,1.416,1.416,0,0,1,1.416,1.416",
    transform: "translate(-353.318 -184.613)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_337",
    "data-name": "Trac\\xE9 337",
    d: "M9.556,243.668a1.351,1.351,0,0,1-.46-.081L0,240.3l.919-2.54,8.632,3.124,7.587-2.81a1.35,1.35,0,0,1,.962.009l7.15,2.8,8.945-2.954.847,2.564L25.634,243.6a1.35,1.35,0,0,1-.916-.025l-7.124-2.794-7.568,2.8a1.349,1.349,0,0,1-.469.084",
    transform: "translate(0 -220.402)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_7",
    "data-name": "Ligne 7",
    x1: 3.493,
    y2: 3.662,
    transform: "translate(3.151 24.371)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_270",
    "data-name": "Rectangle 270",
    width: 7.178,
    height: 2.117,
    transform: "translate(1.654 28.069) rotate(-46.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_8",
    "data-name": "Ligne 8",
    x1: 3.493,
    y2: 3.662,
    transform: "translate(9.114 24.744)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_271",
    "data-name": "Rectangle 271",
    width: 7.178,
    height: 2.117,
    transform: "translate(7.618 28.441) rotate(-46.351)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_9",
    "data-name": "Ligne 9",
    x1: 3.493,
    y2: 3.662,
    transform: "translate(15.152 24.967)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_272",
    "data-name": "Rectangle 272",
    width: 7.178,
    height: 2.117,
    transform: "matrix(0.69, -0.724, 0.724, 0.69, 13.656, 28.665)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_10",
    "data-name": "Ligne 10",
    x1: 3.493,
    y2: 3.662,
    transform: "translate(21.265 24.893)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_273",
    "data-name": "Rectangle 273",
    width: 7.178,
    height: 2.117,
    transform: "matrix(0.69, -0.724, 0.724, 0.69, 19.769, 28.59)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Ligne_11",
    "data-name": "Ligne 11",
    x1: 3.493,
    y2: 3.662,
    transform: "translate(27.75 25.117)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_274",
    "data-name": "Rectangle 274",
    width: 7.178,
    height: 2.117,
    transform: "matrix(0.69, -0.724, 0.724, 0.69, 26.254, 28.814)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Clarifiant",
    d: "M3.241,8.224q-.851,0-1.441-.3T.9,7.076Q.588,6.522.551,5.745.542,5.369.542,4.94t.009-.823Q.588,3.348.9,2.79t.906-.855q.59-.3,1.432-.3.622,0,1.116.165t.842.453q.348.288.54.672t.2.833q.009.082-.05.137t-.142.055H4.878q-.1,0-.165-.05t-.091-.169q-.146-.6-.5-.823t-.887-.22q-.613,0-.979.343t-.393,1.13q-.027.75,0,1.537t.393,1.13q.366.343.979.343.531,0,.887-.224t.5-.819Q4.65,6,4.714,5.955t.165-.046h.869q.082,0,.142.055t.05.137q-.009.448-.2.833t-.54.672q-.348.288-.842.453T3.241,8.224Zm3.906-.091a.236.236,0,0,1-.044,0A.205.205,0,0,1,7.025,8.1a.231.231,0,0,1-.034-.028Q6.928,8,6.928,7.913V1.856q0-.091.064-.156t.156-.064h.759q.091,0,.156.064t.064.156V7.913q0,.091-.064.156a.231.231,0,0,1-.034.028.205.205,0,0,1-.078.032.236.236,0,0,1-.044,0Zm3.577.091q-.476,0-.86-.188t-.608-.5q-.224-.316-.224-.709,0-.64.517-1.02T10.916,5.3l1.253-.183V4.921q0-.384-.192-.595t-.659-.21q-.329,0-.535.133t-.306.352q-.073.119-.21.119H9.544q-.1,0-.151-.055t-.05-.146q.009-.146.119-.357t.348-.407q.238-.2.613-.334t.906-.137q.576,0,.974.142t.636.38q.238.238.348.558t.11.677V7.913q0,.091-.064.156A.231.231,0,0,1,13.3,8.1a.205.205,0,0,1-.078.032.236.236,0,0,1-.044,0h-.741a.273.273,0,0,1-.048,0,.216.216,0,0,1-.043-.012.191.191,0,0,1-.037-.02.2.2,0,0,1-.032-.028q-.059-.064-.059-.156V7.556q-.119.174-.32.325t-.489.247Q11.118,8.224,10.724,8.224Zm.311-.869q.32,0,.581-.137t.412-.425q.151-.288.151-.727V5.873l-.915.146q-.54.082-.805.265t-.265.448q0,.2.124.343t.316.21Q10.825,7.355,11.035,7.355Zm3.751.778a.236.236,0,0,1-.044,0,.205.205,0,0,1-.078-.032.231.231,0,0,1-.034-.028q-.064-.064-.064-.156V3.6q0-.1.064-.165t.156-.064h.741q.091,0,.16.064t.069.165v.375q.21-.293.544-.448t.773-.156h.375q.1,0,.16.064t.059.156v.659q0,.091-.059.156t-.16.064h-.714q-.439,0-.682.247t-.242.677V7.913q0,.091-.064.156a.216.216,0,0,1-.034.028.208.208,0,0,1-.039.02.228.228,0,0,1-.043.012.278.278,0,0,1-.048,0Zm3.815,0a.236.236,0,0,1-.044,0,.205.205,0,0,1-.078-.032.231.231,0,0,1-.034-.028q-.064-.064-.064-.156V3.595q0-.091.064-.156t.156-.064h.759q.1,0,.16.064t.059.156V7.913q0,.091-.059.156a.2.2,0,0,1-.032.028.191.191,0,0,1-.037.02.216.216,0,0,1-.043.012.273.273,0,0,1-.048,0Zm-.037-5.544q-.1,0-.16-.059t-.059-.16V1.71q0-.091.059-.156t.16-.064H19.4q.1,0,.165.064t.064.156v.659q0,.1-.064.16t-.165.059Zm2.964,5.544a.236.236,0,0,1-.044,0,.205.205,0,0,1-.078-.032.231.231,0,0,1-.034-.028q-.064-.064-.064-.156V4.345h-.741q-.091,0-.156-.064t-.064-.156V3.595q0-.091.064-.156t.156-.064h.741V3q0-.549.2-.91t.595-.544q.393-.183,1-.183h1.866q.1,0,.16.064t.059.156v.531q0,.091-.059.156t-.16.064h-1.83q-.366,0-.5.183t-.137.531v.329h2.47q.1,0,.16.064t.059.156V7.913q0,.091-.059.156A.2.2,0,0,1,25.1,8.1a.191.191,0,0,1-.037.02.216.216,0,0,1-.043.012.273.273,0,0,1-.048,0h-.741a.236.236,0,0,1-.044,0,.205.205,0,0,1-.078-.032.231.231,0,0,1-.034-.028q-.064-.064-.064-.156V4.345H22.5V7.913q0,.091-.064.156A.231.231,0,0,1,22.4,8.1a.205.205,0,0,1-.078.032.236.236,0,0,1-.044,0Zm6.258.091q-.476,0-.86-.188t-.608-.5q-.224-.316-.224-.709,0-.64.517-1.02T27.979,5.3l1.253-.183V4.921q0-.384-.192-.595t-.659-.21q-.329,0-.535.133T27.54,4.6q-.073.119-.21.119h-.723q-.1,0-.151-.055t-.05-.146q.009-.146.119-.357t.348-.407q.238-.2.613-.334t.906-.137q.576,0,.974.142t.636.38q.238.238.348.558t.11.677V7.913q0,.091-.064.156a.231.231,0,0,1-.034.028.205.205,0,0,1-.078.032.236.236,0,0,1-.044,0H29.5a.273.273,0,0,1-.048,0,.216.216,0,0,1-.043-.012.191.191,0,0,1-.037-.02.2.2,0,0,1-.032-.028q-.059-.064-.059-.156V7.556q-.119.174-.32.325t-.489.247Q28.18,8.224,27.787,8.224Zm.311-.869q.32,0,.581-.137t.412-.425q.151-.288.151-.727V5.873l-.915.146q-.54.082-.805.265t-.265.448q0,.2.124.343t.316.21Q27.887,7.355,28.1,7.355Zm3.751.778a.236.236,0,0,1-.044,0,.205.205,0,0,1-.078-.032.231.231,0,0,1-.034-.028q-.064-.064-.064-.156V3.595q0-.091.064-.156t.156-.064h.75q.091,0,.156.064t.064.156V3.97q.238-.293.608-.489t.919-.2q.558,0,.97.252t.636.709q.224.457.224,1.1V7.913q0,.091-.064.156a.231.231,0,0,1-.034.028A.205.205,0,0,1,36,8.128a.236.236,0,0,1-.044,0h-.805a.236.236,0,0,1-.044,0,.205.205,0,0,1-.078-.032A.231.231,0,0,1,35,8.068q-.064-.064-.064-.156V5.4q0-.531-.261-.833t-.755-.3q-.476,0-.759.3t-.284.833V7.913q0,.091-.064.156a.231.231,0,0,1-.034.028.205.205,0,0,1-.078.032.236.236,0,0,1-.044,0Zm7.584,0q-.549,0-.924-.192t-.558-.572q-.183-.38-.183-.947V4.345h-.723q-.091,0-.156-.064t-.064-.156V3.595q0-.091.064-.156t.156-.064h.723V1.856q0-.091.059-.156t.16-.064h.741q.091,0,.156.064t.064.156V3.375h1.144q.091,0,.156.064t.064.156v.531q0,.091-.064.156t-.156.064H38.948V6.33q0,.375.133.586t.462.21h.631q.091,0,.156.064t.064.156v.567q0,.091-.064.156A.231.231,0,0,1,40.3,8.1a.205.205,0,0,1-.078.032.236.236,0,0,1-.044,0Z",
    transform: "translate(-40.654 2752.261)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClarifiant);
export default __webpack_public_path__ + "static/media/CLARIFIANT.87d54eb61fd0638b5063cde175f5f40d.svg";
export { ForwardRef as ReactComponent };